const env_var = process.env;

export const client_id = env_var.REACT_APP_CLIENTID;
export const pool_id = env_var.REACT_APP_POOLID;
export const api_url = env_var.REACT_API_URL;
